// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseViewObject } from './BaseViewObject';
import { BEEntity } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { EnumRefStyle } from '../../../../../com/MetaPattern/MDA/MD/UIModel/EnumRefStyle';
import { UIModelComponent } from './UIModelComponent';
import { UIView } from './UIView';
import { EVOAttribute } from './EVOAttribute';
import { EVOAction } from './EVOAction';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 实体视图对象 实体类
 * 实体对应的视图对象
 */
export class ViewObject extends BaseViewObject {
  /** 分页大小 : 默认的分页大小，将此数值设置大一些，就可以不使用分页控件 */
  private _pageSize: number;

  /** 设置：分页大小 */
  public get pageSize() {
    return this._pageSize;
  }

  /** 获取：分页大小 */
  public set pageSize(value: number) {
    this._pageSize = value;
  }

  /** 是否初始加载 : 是否初始加载数据 */
  private _initLoad: boolean;

  /** 设置：是否初始加载 */
  public get initLoad() {
    return this._initLoad;
  }

  /** 获取：是否初始加载 */
  public set initLoad(value: boolean) {
    this._initLoad = value;
  }

  /** 参照方式 : 参照方式 */
  private _refStyle: EnumRefStyle;

  /** 设置：参照方式 */
  public get refStyle() {
    return this._refStyle;
  }

  /** 获取：参照方式 */
  public set refStyle(value: EnumRefStyle) {
    this._refStyle = value;
  }

  /** 是否同步 : 是否同步，true代表显示名称、简介信息与实体同步，否则属于自定义 */
  private _isSync: boolean;

  /** 设置：是否同步 */
  public get isSync() {
    return this._isSync;
  }

  /** 获取：是否同步 */
  public set isSync(value: boolean) {
    this._isSync = value;
  }

  /** 绑定实体 的ID */
  private _bindingBEEntity_ID: string;

  /** 获取：绑定实体 的ID */
  public get bindingBEEntity_ID() {
    return this._bindingBEEntity_ID;
  }

  /** 设置：绑定实体 的ID */
  public set bindingBEEntity_ID(value: string) {
    this._bindingBEEntity_ID = value;
  }

  /** 绑定实体  */
  private _bindingBEEntity: BEEntity;

  /** 获取：绑定实体  */
  public get bindingBEEntity() {
    return this._bindingBEEntity;
  }

  /** 设置：绑定实体  */
  public set bindingBEEntity(value: BEEntity) {
    this._bindingBEEntity = value;
    if (value !== null) {
      this.bindingBEEntity_ID = value.id;
    } else {
      this.bindingBEEntity_ID = '';
    }
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: UIModelComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: UIModelComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 视图 */
  private _views: Array<UIView>;

  /** 获取：视图 */
  public get views() {
    return this._views;
  }

  /** 设置：视图 */
  public set views(value: Array<UIView>) {
    this._views = value;
  }

  /** 属性 */
  private _attributes: Array<EVOAttribute>;

  /** 获取：属性 */
  public get attributes() {
    return this._attributes;
  }

  /** 设置：属性 */
  public set attributes(value: Array<EVOAttribute>) {
    this._attributes = value;
  }

  /** 操作 */
  private _actions: Array<EVOAction>;

  /** 获取：操作 */
  public get actions() {
    return this._actions;
  }

  /** 设置：操作 */
  public set actions(value: Array<EVOAction>) {
    this._actions = value;
  }

  constructor() {
    super();
    this._pageSize = 20;
    this._initLoad = true;
    this._refStyle = EnumRefStyle.DDL;
    this._isSync = true;
    this._bindingBEEntity_ID = '';
    this._bindingBEEntity = null;
    this._component_ID = '';
    this._component = null;
    this._views = new Array<UIView>();
    this._attributes = new Array<EVOAttribute>();
    this._actions = new Array<EVOAction>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ViewObject, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.pageSize = element.pageSize;
      this.initLoad = element.initLoad;
      this.refStyle = element.refStyle;
      this.isSync = element.isSync;
      this.bindingBEEntity_ID = element.bindingBEEntity_ID;
      if (hasReference && element.bindingBEEntity !== null) {
        this.bindingBEEntity = element.bindingBEEntity;
      }
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.pageSize = json.PageSize;
    this.initLoad = json.InitLoad;
    this.refStyle = json.RefStyle as EnumRefStyle;
    this.isSync = json.IsSync;
    this.bindingBEEntity_ID = json.BindingBEEntity_ID;
    // if (json.BindingBEEntity !== null) {
    //   this.bindingBEEntity = BEEntity.Create(json.BindingBEEntity);
    // }
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = UIModelComponent.Create(json.Component);
    // }
    if (json.Views && json.Views.length > 0) {
      json.Views.forEach((element: any) => {
        const uIView = UIView.Create(element);
        // uIView.viewObject = this;
        this.views.push(uIView);
      });
    }
    if (json.Attributes && json.Attributes.length > 0) {
      json.Attributes.forEach((element: any) => {
        const eVOAttribute = EVOAttribute.Create(element);
        // eVOAttribute.viewObject = this;
        this.attributes.push(eVOAttribute);
      });
    }
    if (json.Actions && json.Actions.length > 0) {
      json.Actions.forEach((element: any) => {
        const eVOAction = EVOAction.Create(element);
        // eVOAction.viewObject = this;
        this.actions.push(eVOAction);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.PageSize = this.pageSize;
    json.InitLoad = this.initLoad;
    json.RefStyle = this.refStyle;
    json.IsSync = this.isSync;
    json.BindingBEEntity_ID = this.bindingBEEntity_ID;
    json.Component_ID = this.component_ID;
    if (this.views && this.views.length > 0) {
      json.Views = [];
      this.views.forEach((element) => {
        json.Views.push(element.toJson());
      });
    }
    if (this.attributes && this.attributes.length > 0) {
      json.Attributes = [];
      this.attributes.forEach((element) => {
        json.Attributes.push(element.toJson());
      });
    }
    if (this.actions && this.actions.length > 0) {
      json.Actions = [];
      this.actions.forEach((element) => {
        json.Actions.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('列表设置', 'pageSize', '分页大小', EnumDataType.Int, this.pageSize, true, '默认的分页大小，将此数值设置大一些，就可以不使用分页控件', '', '');
    context.addRow('列表设置', 'initLoad', '是否初始加载', EnumDataType.Bool, this.initLoad, true, '是否初始加载数据', '', '');
    context.addRow('绑定设置', 'isSync', '是否同步', EnumDataType.Bool, this.isSync, true, '是否同步，true代表显示名称、简介信息与实体同步，否则属于自定义', '', '');
    context.addRow('绑定设置', 'bindingBEEntity', '绑定实体', EnumDataType.Reference, this.bindingBEEntity, false, '绑定的业务实体，必须是具体类', 'BEEntity', 'PGRowDataTypeValue:BEEntity');
    return context;
  }

  static Create(json: any): ViewObject {
    const viewObject = new ViewObject();
    viewObject.Deserialize(json);
    viewObject.json = json;
    return viewObject;
  }
}
